import Immutable from 'seamless-immutable';

const MINIMAL_WHITE_THEME = {
  window: '#ffffff',
  sourceBg: '#f4f4f5',
  windowBorder: '#90a0b3',
  tabIcon: '#000000',
  inactiveTabIcon: '#555a5f',
  menuIcons: '#555a5f',
  link: '#0433ff',
  action: '#339933',
  inProgress: '#0433ff',
  complete: '#339933',
  error: '#cc0000',
  textDark: '#000000',
  textLight: '#fcfffd',
};

export default Immutable({
  default: {
    window: '#FFF',
    windowBorder: '#90A0B3',
    tabIcon: '#0078FF',
    inactiveTabIcon: '#0E2F5A',
    menuIcons: '#5A616A',
    textDark: '#000000',
    textLight: '#FFFFFF',
    link: '#0078FF',
    action: '#FF620C',
    error: '#F44235',
    inProgress: '#0078FF',
    complete: '#20B832',
    sourceBg: '#E4EBF1',
  },
  white: MINIMAL_WHITE_THEME,
  minimal: MINIMAL_WHITE_THEME,
  purple: {
    window: '#5D005D',
    sourceBg: '#3A0A3A',
    windowBorder: '#AD5BA3',
    tabIcon: '#ffffcc',
    inactiveTabIcon: '#FFD1D1',
    menuIcons: '#FFD1D1',
    link: '#ffcc33',
    action: '#ffcc33',
    inProgress: '#00e6b3',
    complete: '#a6ff6f',
    error: '#ff1765',
    textDark: '#3c0d68',
    textLight: '#fcfffd',
  },
});
